export default {
  "meeting": {
    applyrecurring: '変更は新しい繰り返しスケジュールに適用されます。過去の会議には影響しません。',
    recurrenceDescribeTwo: '{start}から{end}まで、{loopPulse}週間ごとの{week}に繰り返します',
    wanttodeletethemeetingfollowTwo: '選択した会議とそれ以降の繰り返し会議を削除しますか？',
    loopCycleSelectTips: '繰り返す曜日を選択してください。',

    export: 'エクスポート',
    exportMeetingFileFuncTipsTitle: 'エクスポート確認',
    exportMeetingFileFuncTipsContentOne: 'フィルターが設定されていません。システムはデフォルトで今年の会議記録をエクスポートします。',
    exportMeetingFileFuncTipsContentTwo: '別の期間の会議をエクスポートする場合は、エクスポート前に必要なフィルターを設定してください。',

    myMeetingSearch: '自分の会議',
    meetingTimeSearch: '会議時間',
    meetingRoomsSearch: '会議室',

    Recurring: '繰り返し：',
    wanttodeletethemeetingfollow: 'この会議と以降のすべての会議を削除してもよろしいですか？',
    endTimeCannotBeforeBeginTime: '終了日は開始日より前に設定できません',
    Thismeeting: 'この会議',
    Recurringmeeting: '定期会議',
    Checkin: 'チェックイン：',
    checkinTip: '有効にすると、参加者は会議室スケジューラーのQRコードをスキャンしてチェックインできます。',
    Recurrence_Setrecurrence: '繰り返し設定',
    Recurrence_Start: '開始',
    Recurrence_RepeatEvery: '繰り返し間隔',
    Recurrence_Week: '週',
    Recurrence_end: '終了',
    recurrenceDescribe: '{week}ごとに繰り返します。{start}から{end}まで',
    Recurrence_DoesnotRepeat: '繰り返さない',
    Recurrence_Weekly: '毎週',

    AddressBookUser: 'ユーザー',
    AddressBookPhonebook: 'アドレス帳',

    RoomByPeopleNum1: '2人以下',
    RoomByPeopleNum2: '3～6人',
    RoomByPeopleNum3: '7～10人',
    RoomByPeopleNum4: '11～15人',
    RoomByPeopleNum5: '16～20人',
    RoomByPeopleNum6: '21～30人',
    RoomByPeopleNum7: '30人以上',

    whoAreBound: 'システムアカウントに紐付けられたユーザーは、システムカレンダーで会議を確認できます。メールアドレスを入力したユーザーにはメールで通知が送信されます。通知を受け取るには【マイプロフィール】でメール情報を入力してください。',

    AttendessMeeting: '参加者：',
    SelectAttendessMeetingTip: '参加者を選択',

    MeetingFilter: '会議フィルター',
    HostedbyMe: '自分が主催',
    Invitedby: '自分が参加',
    Otherby: 'その他',

    "AddressIsDuplicated": "連絡先のメールアドレスが重複しています",
    "meetingExpired": "期限切れ",
    titlePhoneFormat: '電話には数字、()、+、- のみ入力できます。',
    "selectField": "ファイルを選択してください",
    "Limit255": "ファイル名は255文字を超えることはできません",
    "nameLimit25": "名前は25文字を超えることはできません",
    "emailLimit50": "メールは50文字を超えることはできません",
    "emailFormatError": "有効なメールアドレスを入力してください",
    "phoneLimit11": "電話番号は最大11桁まで入力可能です",
    "ParticipantsEmail": "参加者のメール：",
    "listIsEmpty": "リストが空です",
    "Startimporting": "アップロード開始",
    "Selectfile": "ファイルを選択",
    "Importfile": "ファイルをインポート",
    "ImportfileTip": "*Outlook形式の CSV（.csv）または vCard（.vcf）ファイルのみインポートできます。",
    "addParticipants": "参加者を追加",
    "multiselectdeselect": "タグ削除のヒント",
    "multiselectselected": "選択済みのヒント",
    "enterOrSelectALabel": "参加者のメールを選択",
    "deleTitleContact": "この連絡先を削除してもよろしいですか？",
    "delTitleContactContent": "連絡先を削除しますか？",
    "deleteContactTitle": "削除する連絡先を選択してください",
    "editcontact": "連絡先を編集",
    "Name": "名前",
    "email": "メール",
    "telephoneNumber": "電話",
    "Addcontact": "連絡先を追加",
    "Importcontactfile": "連絡先をインポート",
    "AddressBook": "アドレス帳",
    "Participants": "参加者：",

    "bindTipContent": "この組織はすでにサードパーティのカレンダーに紐付けされています。Outlook/Teamsで会議をスケジュールしてください。",
    "Productupdatenews": "新しいバージョンの更新がリリースされました。",
    "bookingPerson": "予約者",
    "DeleteMeeting": "会議を削除",
    "wanttodeletethemeeting": "会議を削除しますか？",
    "hasbeendeleted": "会議が削除されました",
    "theMeetingWasAborted": "会議を早く終了",
    "theMeetingWasAbortedContent": "会議を早く終了しますか？",
    "determineTheAbortTask": "会議を早く終了",
    "theMeetingEndedEarly": "会議は早期に終了しました",
    "with": "と共に",
    "Other": "その他",
    "tasks": "タスク",
    "conflict": "競合",
    "meetConflicts": "次の会議時間が重複しています：",
    "itIsNotAllowedToSelectThePastTime": "過去の時間は選択できません",
    "selected": "選択済み",
    "noOverFive": "会議室は5つまで選択可能",
    "approvalOpinions": "承認意見",
    "beyondTheTimeLimitItCannotBeSelected": "時間制限を超える場合、選択できません",
    "startMonth": "開始月",
    "to": "まで",
    "stopMonth": "終了月",
    "didnTStart": "未開始",
    "ONGOING": "進行中",
    "ENDED": "終了済み",
    "hasBeen": "予約済み",
    "booking": "予約",
    "Approval": "承認",
    "MeetingRoom": "会議室",
    "AllRoom": "全ての部屋",
    "Available": "利用可能",
    "Initiate": "会議を開始",
    "MeetingApproval": "会議承認",
    "PreviousMonth": "前月",
    "Today": "今日",
    "NextMonth": "翌月",
    "YearMonth": "年/月",
    "TimeDisplay": "時間表示",
    "MeetingTitleAbbreviation": "会議タイトル略称",
    "InitiateMeeting": "会議を開始",
    "PendingMeetings": "今後の会議",
    "AllMeetings": "全ての会議",
    "noMeetings": "現在参加する会議はありません",
    "NotStarted": "未開始",
    "Organizer": "主催者",
    "MeetingDateTime": "日付と時間",
    "MeetingLocation": "場所",
    "MeetingSubject": "会議テーマ",
    "Invited": "招待者",
    "PeopleAccepted": "参加承認者",
    "EditMeeting": "会議を編集",
    "CancelMeeting": "会議をキャンセル",
    "InitiateEditMeeting": "会議を開始/編集",
    "Subject": "件名",
    "Presenter": "発表者：",
    "DateTime": "日付と時間",
    "TimeAndZone": "タイムゾーン",
    "Attendees": "出席者",
    "Addrequiredattendees": "必須出席者を追加",
    "SelectRooms": "部屋を選択",
    "Reminder": "リマインダー",
    "Remindbeforestart": "開始前に通知",
    "Confirm": "確認",
    "topic": "件名：",
    "topicplace": "新しい会議タイトル：",
    "speaker": "発表者：",
    "speakerplace": "発表者情報を入力してください",
    "DateAndTime": "日付と時間：",
    "TimeZone": "タイムゾーン",
    "EndDate": "終了日",
    "Rooms": "部屋：",
    "Notes": "備考：",
    "MeetingRoomApproval": "会議室承認",
    "PendingApproval": "承認待ち",
    "Approved": "承認済み",
    "nopendingapprovals": "承認待ちはありません",
    "Applicant": "申請者",
    "UsageTime": "使用時間",
    "ApprovalResult": "承認結果",
    "ApprovalComments": "承認コメント",
    "Approve": "承認",
    "Reject": "拒否",
    "Search": "検索",
    "Filter": "フィルター",
    "scanTheQRCodeToSignIn": "QRコードをスキャンして出席確認"
  },
  "NPS": {
    "Relay": "リレー",
    "RelaySettings": "リレー設定",
    "DevicePower": "デバイス電源制御",
    "DeviceElevation": "昇降制御",
    "LinageWithNPSPower": "NPS電源との連動",
    "PresentationSwitch": "プレゼンテーションスイッチ",
    "Duplicate": "複製",
    "LinkagewithNPSPowe": "NPS電源との連動",
    "npsTooltip": "USBデバイスは、HDMI OUT 1 に切り替えられたPCホストからのみ呼び出せます。",
    "nmpTooltip": "「複製」ボタンをクリックすると、他のディスプレイに画面内容をミラーリングし、複数の画面で表示を同期できます。"
  },
  "textTemplate": {
    "template2513": "火災緊急放送",
    "template2514": "避難経路図に従い、非常口および火災出口から安全な場所へ避難してください。",
    "moreTemplate": "テンプレート上限に達しました",
    "add": "追加",
    "SetTemplate": "テンプレートを設定",
    "Emergency": "緊急",
    "General": "一般",
    "BroadcastDevices": "放送機器：",
    "selectBroadcastDevices": "放送機器を選択してください",
    "All": "すべて",
    "AddTemplate": "テンプレートを追加",
    "EditTemplate": "テンプレートを編集",
    "deleteTemplage": "選択したテンプレートを削除してもよろしいですか？",
    "title": "テンプレートを削除",
    "selectTemplage": "テンプレートを選択してください！",
    "DeleteCancelled": "削除がキャンセルされました！",
    "DeletedSuccessfully": "削除に成功しました！",
    "noData": "使用可能なテンプレートがありません。右上のボタンをクリックしてテンプレートを追加してください。",
    "TemplateTitle": "テンプレートタイトル：",
    "BroadcastType": "放送タイプ：",
    "BroadcastTypeDialog": "放送タイプ：",
    "selectBroadcastType": "放送タイプを選択してください",
    "BroadcastDuration": "放送時間：",
    "BroadcastDevice": "放送機器：",
    "BroadcastContent": "放送内容："
  },
  "common": {
    "mediaTimeStateNotifyErrorTitle": "エラー！",
    "mediaTimeStateNotifyErrorContent": "ストリーミングサービスの期限が切れています。代理店に連絡して期限を更新してください。",
    "mediaTimeStateNotifyWarnTitle": "注意！",
    "mediaTimeStateNotifyWarnContent": "現在、試用状態にあり、放送およびライブストリーミングは最大3台の端末にのみ配信可能です。",
    "mediaTimeStateNotifySuccessTitle": "更新成功",
    "mediaTimeStateNotifySuccessContent": "ストリーミングサービスは通常利用可能です。ありがとうございます。",
    "company": "会社名：",
    "tableAddress": "住所：",
    "createTime": "作成日時：",
    "email": "メール：",
    "phone": "電話：",
    "Trial": "試用",
    "TrialWorkstation": "現在、試用状態にあり、放送およびライブストリーミングは最大3台の端末にのみ配信可能です。",
    "Normal": "通常",
    "NormalWorkstation": "ストリーミングサービスの有効期間は",
    "to": "まで",
    "Advent": "開始",
    "AdventWorkstationOne": "ストリーミングサービスは",
    "AdventWorkstationTwo": "に期限切れとなります。通常利用のため、代理店に連絡して更新してください。",
    "Expired": "期限切れ",
    "ExpiredWorkstation": "ストリーミングサービスの期限が切れています。代理店に連絡して期限を更新してください。"
  },
  "route": {
    "dashboard": "ダッシュボード",
    "i18n": "I18n",
    "Devices": "デバイス",
    "Broadcast": "放送",
    "Schedule": "スケジュール",
    "Resources": "リソース",
    "Live": "ストリーミング",
    "meetings": "会議"
  },
  "navbar": {
    "updates": "最新の更新",
    "logOut": "ログアウト",
    "screenfull": "全画面",
    "oprofile": "マイプロフィール",
    "settings": "設定",
    "language": "言語",
    "BackTianwa": "天和に戻る",
    "newUserGuide": "新規ユーザーガイド"
  },
  "feedback": {
    "Feedback": "フィードバック",
    "email": "フィードバック用にメールアドレスを入力してください。",
    "content": "当社製品向上のためのご意見・ご感想をお寄せください。ご協力ありがとうございます。",
    "submit": "送信",
    "emailNoEmpty": "メールアドレスは空にできません",
    "emailTrueRule": "正しいメール形式を入力してください",
    "contentNoEmpty": "内容を入力してください",
    "feedbackSuccess": "フィードバック成功",
    "feedbackFailed": "フィードバック失敗",
    "emailNoChinese": "メールボックスに中国語は使用できません",
    "emailLength": "5文字から50文字の間で入力してください",
    "emailSpecialString": "メールボックスに特殊文字列を含めることはできません"
  },
  "login": {
    checkPasswordTitleTwo: '6文字以上で、英字と数字を含むパスワードを設定してください。特殊文字も使用可能です（制限なし）。',
    captcha: '認証コード',
    checkPasswordTitle: 'パスワードは6文字以上で、数字のみは不可です',
    "title": "ようこそ",
    "logIn": "ログイン",
    "consoleLogin": "コンソールログイン",
    "username": "ユーザー名",
    "password": "パスワード",
    "any": "任意",
    "thirdparty": "または接続",
    "thirdpartyTips": "ローカルではシミュレーションできませんので、ご自身の業務シミュレーションと組み合わせてください！！！",
    "placeholder": "[\n  \"ユーザー名\",\n  \"パスワード\",\n  \"検証コード\"\n]",
    "userNameTitle": "ユーザー名が間違っています！",
    "forget": "忘れましたか？",
    "loginTitle0": "ログイン成功！",
    "loginTitle1000": "ユーザー名またはパスワードが間違っています！",
    "loginTitle1001": "ユーザー名とパスワードは必ず入力してください！",
    "loginTitle1002": "検証コードは必ず入力してください！",
    "loginTitle1003": "ユーザー状態が不正です。ログインに失敗しました！",
    "loginTitle1004": "検証コードエラー！",
    "loginTitle1005": "ログインしていません。先にログインしてください！",
    "loginTitle1006": "2つのパスワードが異なります！",
    "loginTitleUserName": "ユーザー名は必ず入力してください！",
    "loginTitlePwd": "パスワードは必ず入力してください！",
    "loginTitleVercode": "検証コードは必ず入力してください！",
    "titleLoginNameFormat": "アカウントは文字、または文字と数字で構成する必要があります。",
    "privacy": "Q-NEX User Privacy Policy",
    "privacyContent": "Agree to",
    "_zh": "中文(简体)",
    "_en": "_English",
    "_ko": "한국어",
    "_zh_ft": "中文(繁體)"
  },
  "home": {
    "btnDevices": "デバイス",
    "btnRoadcast": "放送",
    "btnResources": "リソース",
    "btnLive": "ストリーミング",
    "meetings": "会議",
    "todaySchedule": "今日のスケジュール",
    "allSkedules": "すべてのスケジュール",
    "details": "詳細",
    "btnStart": "開始",
    "titleContent": "ご挨拶！Q-NEXコンソールがあなたのサービスにあります。始めましょう！",
    "btnExit": "終了"
  },
  "devices": {
    "ptzCamera": "PTZカメラ",
    "start": "開始",
    "stop": "停止",
    "nmpPowerOff_mandatory": "放送中（任意）",
    "nmpPowerOff_nomandatory": "放送中（任意）。実行を続行しますか？",
    "nmpsPowerOff_mandatory": "一部のNMPは放送中（必須）。",
    "nmpsPowerOff_nomandatory": "一部のNMPは放送中（任意）。実行を続行しますか？",
    "reset": "リセット",
    "displayedInTheControlArea": "コントロールセンターに表示",
    "dragOrder": "ドラッグ順序",
    "areaSettingTwoNotice": "*RS232、AC制御、およびリモコンは、ダッシュボードでのNMPバインド状態に応じてコントロールセンターに表示されます。",
    "areaSettingThreeNotice": "*CBX制御は、ダッシュボードでのNMPバインド状態に応じてコントロールセンターに表示されます。",
    "controlSet": "コントロールセンター設定",
    "vcbNoLine": "オンラインのCBXデバイスがありません",
    "vcbNoBound": "CBXデバイスがバインドされていません",
    "tscNoBound": "TSCのRS232はデータにバインドされていません。ダッシュボードでバインドするよう管理者に通知してください。",
    "light": "電源制御",
    "vcbpower": "電源",
    "rs232Control": "シリアル制御",

  "CBX": {
    "powerSupplyON": "電源オン",
    "powerSupplyOFF": "電源オフ",
    "lockScreenON": "ロックオン",
    "lockScreenOFF": "ロックオフ",
    "childLockON": "チャイルドロックオン",
    "childLockOFF": "チャイルドロックオフ",
    "energySavingON": "省エネオン",
    "energySavingOFF": "省エネオフ",
    "signalSourceSwitchingON": "OPS",
    "signalSourceSwitchingOFF": "Android",
    "volumeAdjustment": "スピーカー",
    "brightAdjustment": "明るさ",
    "other": "その他の機能…"
  },

    "InterfaceOne": "インターフェース1",
    "InterfaceTwo": "インターフェース2",
    "abcStyleP": "申し訳ありません！TSCと(NMP, MBX, NPS, NDP100, NDP500)は同時に選択できません",
    "masterControl": "メイン",
    "powerSupply": "電源",
    "RecordingControl": "録画制御",
    "RecordingControlSystem": "講義キャプチャシステム",
    "LiquidCrystal": "インタラクティブLCDディスプレイ",
    "projector": "プロジェクター",
    "othertype": "その他",
    "lockScreen": "ロック",
    "childLock": "チャイルドロック",
    "energySaving": "省エネ",
    "signalSourceSwitching": "入力ソース",
    "volumeAdjustment": "スピーカー",
    "brightAdjustment": "明るさ",
    "other": "その他の機能",
    "otherFunction": "機能",
    "send": "送信",
    "ON": "ON",
    "OFF": "OFF",
    "_POWERA": "Display Power",
    "_POWERB": "External Power",
    "_MAGNETICLOCK": "マグネティッククロック",
    "_HDMI1": "HDMI in 1",
    "_HDMI2": "HDMI in 2",
    "_HDMI3": "HDMI in 3",
    "_HDMIA": "HDMI out A",
    "_HDMIB": "HDMI out B",
    "_HDMIC": "HDMI out C",
    "_AIR": "エアコン",
    "titleDevices": "グループフィルター：",
    "content": "検索",
    "selectALL": "全て選択",
    "SelectRecentPage": "現在のページを選択",
    "controlPanel": "コントロールセンター",
    "displayInputSwitch": "ディスプレイ入力切替",
    "chooseINPUTSources": "入力ソースを選択",
    "speakerVolume": "音量",
    "bass": "低音",
    "treble": "高音",
    "MICVolume": "マイク音量",
    "AirConditioning": "エアコン",
    "model": "モデル",
    "setTemp": "温度設定",
    "fanSpeed": "ファンスピード",
    "bold": "スイング",
    "projectionScreen": "投影スクリーン",
    "electronicLock": "電気錠",
    "electronicLock1": "電気錠",
    "selectDevices": "デバイスまたはデバイスグループを選択してください",
    "isCompelType": "必須放送のためデバイス制御は利用できません。後でもう一度お試しください。",
    "mainPower": "メイン電源",
    "extraPower": "追加電源",
    "power": "電源",
    "hdmiBroadcast": "放送",
    "equipmentState1": "電源オン",
    "equipmentState2": "電源オフ",
    "equipmentState3": "オフライン",
    "main": "メイン",
    "external": "外部",
    "ProjectionScreen": "投影スクリーン",
    "UP": "上",
    "DOWN": "下",
    "LOCK": "ロック",
    "UNLOCK": "ロック解除",
    "PleaseDevice": "左側のデバイスを選択してください",
    "RemoteControl": "リモコン",
    "Action": "アクション",
    "Devicefilter": "デバイスフィルター",
    "DeviceStatus": "ステータス",
    "DeviceType": "タイプ",
    "currentAudioSource": "現在の音声ソース",
    "audioSwitching": "音声出力切替"
  },
  "broadcast": {
    "isBoarding": "（放送中）",
    "last3Days": "過去3日間",
    "last7Days": "過去7日間",
    "last30Days": "過去30日間",
    "historyRecord": "履歴",
    "SelectDestination": "1.宛先を選択",
    "BroadcastingConsole": "2.放送コンソール",
    "Notification": "通知",
    "btnStop": "停止",
    "btnStart": "開始",
    "Letters60": "（60文字未満）",
    "Letters300": "（300文字未満）",
    "LastingTime": "継続時間：",
    "Title": "タイトル：",
    "Content": "内容：",
    "Cannotquit": "必須放送",
    "ChooseMedia": "メディアファイルを選択",
    "Broadcasting": "放送中",
    "dialogTitle": "動画＆音声リソース",
    "SortBy": "並び替え",
    "btnBake": "前に戻る",
    "cancel": "キャンセル",
    "confirm": "確認",
    "save": "保存",
    "coxAll": "すべて",
    "PublicCloud": "公共ストレージ",
    "IndividualCloud": "個人ストレージ",
    "selFile": "ファイルまたはグループを選択してください。",
    "StopBroadcast": "放送停止",
    "StartBroadcasting": "放送開始",
    "StopBroadcasting": "放送停止",
    "ForceQuit": "強制終了",
    "PleaseMediaFile": "メディアファイルを選択してください",
    "PleaseDevice": "デバイスを選択してください",
    "broadcast_0": "放送開始",
    "broadcast_2500": "メディアサーバーに接続可能なデバイス数を超えています",
    "broadcast_2501": "放送ファイルエラー",
    "broadcast_2502": "放送終了",
    "broadcast_2503": "メディアサーバー情報を取得できません",
    "broadcast_2510": "注意！現在、試用状態です。最大3台の端末が放送コマンドを受信できます。選択した端末数をご確認ください。",
    "broadcast_2018": "ストリーミングサービスが停止しています",
    "broadcast_2019": "ストリーミングサービスの期限が切れています",
    "broadcast_2512": "テンプレート数の上限を超えています。",
    "broadcast_2513": "火災緊急放送",
    "broadcast_2514": "避難経路図に従い、非常口および火災出口から安全な場所へ避難してください。",
    "broadcast_2006": "デバイスが見つかりません",
    "broadcast_2": "ディスクサービスが異常です",
    "broadcast_2515": "放送機能のないデバイスを選択してください",
    "broadcast_2516": "NMPでサポートされる最大解像度を超えるファイルを選択してください",
    "broadcast_2517": "NDP500でサポートされる最大解像度を超えるファイルを選択してください",
    "broadcast_Title": "放送警告",
    "broadcast_TitleNDP500": "NDP500放送警告",
    "broadcast_content": "デバイスは最大4K@30FPSをサポートし、最適解像度は1080P@30FPSです。",
    "broadcast_contentNDP500": "NDP500/600は最大1080P@30FPSをサポートし、最適解像度は720P@30FPSです。",
    "broadcast_noSupported": "以下の選択された動画は放送に対応していません：",
    "broadcast_noSupportedNDP500": "以下の選択された動画はNDP500/600での放送に対応していません："
  },
  "resources": {
    "uploadNameLengthError": "アップロードするファイル名は100文字を超えることはできません！",
    "onUploadFile": "アップロードするファイルがありません",
    "open": "開く",
    "fold": "折りたたむ",
    "close": "閉じる",
    "PublicCloud": "公共ストレージ",
    "IndividualCloud": "個人ストレージ",
    "TransfersHistory": "転送履歴",
    "btnDownload": "ダウンロード",
    "btnDelete": "削除",
    "btnUploadFile": "ファイルをアップロード",
    "btnNewFolder": "新しいフォルダー",
    "btnBake": "前に戻る",
    "coxAll": "すべて",
    "uploadError": "アップロードするファイルのサイズは1Gを超えることはできません！",
    "MD5": "MD5を検証",
    "merge": "マージ中",
    "transcoding": "トランスコード中",
    "uploadFailed": "アップロード失敗",
    "fileError": "ファイル読み取りエラー、ファイルを確認してください。",
    "tableName": "名前",
    "tableSize": "サイズ",
    "tableType": "種類",
    "tableTimeAdded": "追加日時",
    "tableAction": "操作",
    "btnRename": "名前変更",
    "btnMoveTo": "移動先...",
    "ClearAll": "すべてクリア",
    "cancel": "キャンセル",
    "confirm": "確認",
    "save": "保存",
    "addSuccess": "追加成功！",
    "addError": "追加失敗！",
    "editSuccess": "編集成功！",
    "editError": "編集失敗！",
    "delSuccess": "削除成功！",
    "delError": "削除失敗！",
    "diskError3000": "合計容量を超えたため操作に失敗しました！",
    "diskError3001": "公共スペースの使用量を超えたため操作に失敗しました！",
    "diskError3002": "個人スペースの使用量を超えたため操作に失敗しました！",
    "diskError3003": "データが見つかりません。メディアサーバーがバインドされているか確認してください！",
    "diskError3004": "フォルダー名は既に存在します！",
    "diskError3005": "フォルダーの取得に失敗しました！",
    "diskError3006": "同じ階層で99以上のフォルダーを作成できません！",
    "diskError3007": "同じファイル名が存在するため変更に失敗しました！",
    "diskError3008": "同じフォルダー名が存在するため変更に失敗しました！",
    "diskError3009": "ファイルが残りの容量を超えたためアップロードに失敗しました！",
    "diskError3010": "アップロードに失敗しました！",
    "diskError3011": "ファイル検証に失敗しました。再アップロードしてください！",
    "diskError3012": "プライベートクラウドのアドレス取得に失敗しました。操作に失敗！",
    "diskError3013": "複数ファイルの結合は100Mを超えることはできません。大きなファイルは個別にダウンロードしてください！",
    "diskError3014": "圧縮に失敗しました。ファイルを再選択してダウンロードしてください！",
    "diskError3015": "この操作を行うには権限が必要です",
    "downloadError": "ダウンロードに失敗しました！",
    "mobileError": "移動に失敗しました！",
    "root": "すべてのファイル",
    "Name": "名前",
    "Size": "サイズ",
    "Type": "種類",
    "uploadFile": "ファイルをアップロード",
    "newFolder": "新しいフォルダー",
    "tableTime": "日時",
    "permission": "権限が不足しています！",
    "notifyTitle": "通知",
    "notifyContent": "ユーザーはアクセス権が不足しています！",
    "sortFileName": "ファイル名",
    "sortTime": "日時",
    "sortSize": "サイズ",
    "sortType": "種類",
    "moveTo": "移動先",
    "test": "新規",
    "delTitle": "削除？",
    "delTitleContent": "選択した内容はデータベースから削除されます。この操作は元に戻せません。続行してもよろしいですか？",
    "delCancelButton": "キャンセル",
    "delConfirmButton": "確認"
  },
  "userMge": {
    "userName": "ユーザー名：",
    "jobNumber": "社員ID：",
    "email": "メール：",
    "phone": "電話：",
    "group": "グループ：",
    "oldPassword": "現在のパスワード：",
    "newPassword": "新しいパスワード：",
    "confirmNewPassword": "新しいパスワード確認：",
    "btnSave": "変更を保存",
    "titleChangePassword": "パスワード変更",
    "titleMyProfile": "マイプロフィール",
    "name": "ニックネーム：",
    "error1400": "アカウント（カスタム）は既に存在します。操作に失敗しました！",
    "error1401": "アカウント（システム生成）は既に存在します。操作に失敗しました！",
    "error1402": "グループが存在しません。インポートに失敗しました！",
    "error1403": "データエラー",
    "error1404": "権限不足",
    "selUser": "ユーザーを選択してください！",
    "error1405": "役割の取得に失敗しました",
    "error1406": "インポートされたユーザー情報のデータ形式が正しくありません",
    "error1407": "メールアドレスは既に存在し、操作に失敗しました。",
    "error1408": "電話番号は既に存在し、操作に失敗しました。",
    "editSuccess": "保存に成功しました！",
    "ChangePassword": "パスワード変更",
    "UserPrivacyAgreement": "ユーザープライバシーポリシー"
  },
  "information": {
    "_2602": "デバイスオフライン",
    "_2603": "放送に失敗しました",
    "_2604": "放送が中断されました",
    "_2605": "クラウドストレージ容量がいっぱいです",
    "_2606": "分前",
    "_2607": "時間前",
    "_2609": "故障が発生しました、お願いします",
    "_2609_a": "ここをクリック",
    "_2609_time": "タイムリーに対応",
    "userType": "スーパー管理者",
    "unreadNoticeFirst": "未読メッセージ優先",
    "sortByTime": "時間で並び替え",
    "coxRead_1": "未読",
    "coxRead_0": "既読",
    "allCoxRead": "すべて既読にする",
    "load": "読み込み中...",
    "noData": "これ以上データはありません",
    "viewALLMessages": "すべてのメッセージを表示"
  },
  "input": {
    "select": "選択してください",
    "thisField": "この項目は必須です。",
    "titleShooleNub60": "60文字未満",
    "titleShooleNub300": "300文字未満",
    "Offline": "オフライン"
  },
  "schedule": {
    "OnlyManual": "手動のみ",
    "runStartNow": "タスク実行",
    "runStopNow": "タスク停止",
    "tackExecutionStart": "タスク実行中",
    "tackExecutionStop": "タスク実行停止",
    "dehumidification": "除湿",
    "airSupply": "送風",
    "masterControl": "メイン：",
    "powerSupply": "電源",
    "lockScreen": "ロック",
    "RecordingControl": "録画制御",
    "RecordingControlSystem": "講義キャプチャシステム",
    "LiquidCrystal": "インタラクティブLCDディスプレイ",
    "projector": "プロジェクター",
    "othertype": "その他",
    "childLock": "チャイルドロック",
    "energySaving": "省エネ",
    "signalSourceSwitching": "入力ソース",
    "other": "その他の機能：",
    "otherFunction": "機能",
    "send": "送信",
    "ON": "オン",
    "OFF": "オフ",
    "btnAddSchedule": "復元",
    "EditSchedulelist": "スケジューラ編集",
    "AddSchedulelist": "スケジューラ追加",
    "RestoreSchedulelist": "復元",
    "btn": "キャンセル",
    "btnNewList": "新しいスケジューラ",
    "ListName": "名前",
    "Cannotquit": "必須",
    "NOCannotquit": "いいえ",
    "ListValidityPeriod": "有効期間",
    "ListDescription": "説明",
    "currentSchedule": "スケジューラ一覧",
    "historySchedule": "履歴一覧",
    "selectTime": "時間",
    "selectTimeTable": "時間",
    "taskType": "タスクタイプ",
    "selectBroadcasting": "放送",
    "selectDeviveControl": "デバイス制御",
    "newSchedule": "新しいタスク",
    "newChecklist": "新しいチェックリスト",
    "titleStatus": "ステータス",
    "titleType": "種類",
    "titleStartTime": "開始時間",
    "titleEndTime": "終了時間",
    "titleRepeat": "繰り返し",
    "titleName": "名前",
    "titleAction": "操作",
    "tableEnabled": "有効",
    "tablePaused": "一時停止",
    "tableEdit": "編集",
    "tableDelete": "削除",
    "tableVolumeEdit": "放送音量",
    "tableBroadcastTitle": "タイトル",
    "tableBroadcastContent": "内容",
    "tableBroadcastList": "リスト",
    "tableBroadcast": "強制的",
    "btnRemoveCompletely": "完全に削除",
    "btnEnabled": "有効タスク",
    "btnPaused": "タスク無効化",
    "btnDelete": "削除",
    "repeat0": "月",
    "repeat1": "火",
    "repeat2": "水",
    "repeat3": "木",
    "repeat4": "金",
    "repeat5": "土",
    "repeat6": "日",
    "dialogTitleAdd": "新しいデバイス制御タスク",
    "dialogTitleEdit": "デバイス制御タスク編集",
    "newBroadcastingSchedule": "新しい放送タスク",
    "editBroadcastingSchedule": "放送タスク編集",
    "chooseDevice": "デバイス選択",
    "timeSetting": "時間設定",
    "controlBroadcasting": "放送オプション",
    "controlOption": "制御オプション",
    "scheduleName": "タスク名：",
    "destination": "宛先",
    "timeTilte": "時間",
    "repeatTitle": "繰り返し",
    "dialogRepeat0": "月",
    "dialogRepeat1": "火",
    "dialogRepeat2": "水",
    "dialogRepeat3": "木",
    "dialogRepeat4": "金",
    "dialogRepeat5": "土",
    "dialogRepeat6": "日",
    "dialogOnceType": "一度",
    "dialogRepeatType": "繰り返し",
    "Manual": "手動",
    "ManualContent": "設定完了後、これらのタスクを手動で実行できます。",
    "mainPower": "メイン電源",
    "powerControl": "電源制御",
    "tableDisplayInputSwitch": "ディスプレイ入力切替",
    "tableAirConditioning": "エアコン",
    "tableProjectionScreen": "投影スクリーン",
    "tableElectronicLock": "電気ロック",
    "interactiveFlatPanel": "Interactive Flat Panel",
    "displayInputSwitch": "ディスプレイ入力切替",
    "speakerVolume": "音量",
    "MICVolume": "マイク音量",
    "ProjectionScreen": "投影スクリーン",
    "ElectronicLock": "電気ロック",
    "AirConditioning": "エアコン",
    "AirConditioningPower": "電源",
    "AirConditioningModel": "モデル",
    "AirConditioningTEMP": "温度",
    "AirConditioningFanSpeed": "風速",
    "OPEN": "開",
    "CLOSE": "閉",
    "UP": "上",
    "DOWN": "下",
    "PowerOFF": "オフ",
    "PowerON": "オン",
    "ModelAuto": "自動",
    "ModelCool": "冷房",
    "ModelHeat": "暖房",
    "ModelAir": "送風",
    "TEMPLow": "低",
    "TEMPMiddle": "中",
    "TEMPHigh": "高",
    "btnSave": "保存",
    "btnNext": "次へ",
    "StartTime": "開始時間",
    "StopTime": "終了時間",
    "Mandatory": "必須",
    "Video": "ビデオ＆オーディオ",
    "Notification": "通知",
    "btnFile": "メディアファイルを選択",
    "LastingTime": "持続時間",
    "textTitle": "タイトル",
    "textContent": "内容",
    "textTitleLetters": "60文字未満",
    "textContentLetters": "320文字未満",
    "CannotquitYES": "はい",
    "CannotquitNo": "いいえ",
    "YES": "はい",
    "No": "いいえ",
    "delTitleContent": "本当にこのスケジューラを削除しますか？",
    "delTitleListContent": "削除されたスケジューラは履歴一覧に移動され、復元可能です",
    "deleListTitle": "スケジューラを削除しますか？",
    "delTitleListContent1": "スケジューラを削除すると関連するタスクがクリアされます。確認してください。",
    "deleListTitle1": "本当にこのスケジューラを削除しますか？",
    "delTitle": "削除しますか？",
    "btnConfirm": "確認",
    "coxAll": "すべて",
    "coxBroadcasting": "放送",
    "coxDeviveControl": "デバイス制御",
    "rdMandatory": "はい",
    "noRdMandatory": "いいえ",
    "startDate": "開始日",
    "endedDate": "終了日",
    "or": "-",
    "broadcastingType": "タイプ",
    "ChooseTime": "時間を選択",
    "ChooseDate": "日付を選択",
    "newScheduleList": "新しいスケジューラ",
    "editScheduleList": "スケジューラ編集",
    "listName": "名前",
    "listValidityPeriod": "有効期間",
    "listDescription": "説明",
    "cancel": "キャンセル",
    "confirm": "確認",
    "save": "保存",
    "addSuccess": "追加に成功しました！",
    "addError": "追加に失敗しました！",
    "editSuccess": "編集に成功しました！",
    "editError": "編集に失敗しました！",
    "delSuccess": "削除に成功しました！",
    "delError": "削除に失敗しました！",
    "restoreSuccess": "スケジュール一覧を正常に復元しました",
    "restoreError": "スケジュール一覧の復元に失敗しました",
    "restoreTitleContent": "この時間はリストのスケジュール時間と重複しています。再度選択してください",
    "Enabled": "有効",
    "Paused": "一時停止",
    "Title": "タイトル：",
    "Content": "内容：",
    "errorScheduleNameRequired": "タスク名は必須です",
    "errorDeviceRequired": "対象デバイスを選択してください",
    "deleTitle": "本当にこのタスクを削除しますか？",
    "loopList": "ループ一覧",
    "errorPleaseDateRange": "日付範囲を選択してください",
    "addError_2009": "スケジューラ名が重複しています",
    "conflicts": "タスク時間が以下と重複しています：",
    "Pleaseagain": "再入力してください",
    "errorScheduleName": "タスク名",
    "errorListName": "スケジューラ名",
    "today": "今日",
    "yesterday": "昨日",
    "thisWeek": "今週",
    "lastWeek": "先週",
    "lastMonth": "先月",
    "thisMonth": "今月",
    "times": "回数",
    "TimeConflicts": "時間が重複しています",
    "editError_2006": "デバイスが見つかりません",
    "editError_2010": "タスク名が重複しています",
    "editError_2100": "タスクは期限切れで、開始できません。",
    "ListTimeExpired": "スケジューラ時間が期限切れです。再度選択してください",
    "TimeExpired": "時間切れ",
    "ControlOption": "制御オプションが不足しています",
    "Pleaseleastone": "少なくとも1つの制御オプションを選択してください",
    "Enter": "入力",
    "TitleFilled": "タイトルは必須です",
    "ContentFilled": "内容は必須です",
    "PleaseMediaFile": "メディアファイルを選択してください",
    "PleaseSchedule": "タスクを選択してください",
    "delTitleScheduleContent": "削除されたタスクは復元できません。",
    "deleTitleSchedule": "本当にこのタスクを削除しますか？",
    "deleteScheduleTitle": "削除するタスクを選択してください",
    "PleaseFillColumn": "スケジューラ名を入力してください",
    "PleaseDate": "日付を選択してください",
    "Previous": "前へ",
    "RemoteControl": "リモコン",
    "taskhasexpired": "このタスクは期限切れです。作成者に連絡して時間を更新してください。",
    "execute": "実行",
    "broadcastingList": "放送一覧",
    "volumeSuccess": "音量設定に成功しました",
    "volumeFailed": "音量設定に失敗しました"
  },
  "live": {
    "StreamingRoom": "ストリーミングルーム",
    "btnAddNewRoom": "新しいルームを追加",
    "Steaming": "ストリーミング",
    "Creater": "ホスト：",
    "Address": "RTMPアドレス：",
    "StreamingURL": "ライブストリーミングURL：",
    "DestinationNMP": "宛先NMPを選択：",
    "stop": "停止",
    "stat": "開始",
    "btnCope": "クリックしてコピー",
    "QRcode": "QRコード",
    "Refresh": "更新",
    "AddNewRoomTitle": "新しいストリーミングルームを追加",
    "editNewRoomTitle": "ストリーミングルームを編集",
    "roomName": "ルーム名：",
    "cancel": "キャンセル",
    "confirm": "確認",
    "save": "保存",
    "delTitleContent": "本当にこのスケジュールを削除しますか？",
    "delTitle": "削除しますか？",
    "delCancelButton": "キャンセル",
    "delConfirmButton": "確認",
    "addSuccess": "追加に成功しました！",
    "addError": "追加に失敗しました！",
    "editSuccess": "編集に成功しました！",
    "editError": "編集に失敗しました！",
    "delSuccess": "削除に成功しました！",
    "delError": "削除に失敗しました！",
    "Stopstreaming": "ストリーミング停止",
    "Startstreaming": "ストリーミング開始",
    "error2504": "メディアサーバーのライブストリーミングアドレスを取得できません",
    "error2505": "ストリーミングルーム名が重複しています",
    "error2506": "デバイスは他のストリーミング信号によって使用されています",
    "error1900": "アクセスしたパラメータが空です",
    "error2503": "メディアサーバー情報を取得できません",
    "error2507": "ライブストリーミングアドレスが重複しています",
    "copySuccess": "内容がクリップボードにコピーされました。",
    "copyError": "ブラウザは自動コピーをサポートしていません",
    "flashControl": "「Flashがインストールされていないか、無効になっています。インストールまたは有効化後に再試行してください。」",
    "liveStreaming": "ライブストリーミングソースが見つかりません。",
    "btnflash": "インストール/有効化",
    "serverAddress": "サーバーアドレス",
    "addressKey": "キー：",
    "watchingAddress": "視聴アドレス",
    "audioOnly": "音声のみ",
    "enterTheKey": "キーは必須です。"
  },
  "guidepages": {
    "next": "次の制御デバイス",
    "next1": "次に制御を試す",
    "next2": "次の放送",
    "next3": "次に放送を開始",
    "next4": "次に放送を停止",
    "next5": "次にテキスト放送",
    "next6": "次のタスク設定",
    "next7": "次に新しいタスクを追加",
    "next8": "次の履歴一覧",
    "next9": "次のクラウドストレージ",
    "next10": "次のライブストリーミング",
    "next11": "次にライブストリーミングを設定",
    "exit": "終了",
    "guideContent": "ガイド内容",
    "btnHomepage": "ホームページ",
    "btnDevices": "デバイス",
    "btnBroadcast": "放送",
    "btnSchedule": "スケジュール",
    "btnResources": "リソース",
    "btnStreaming": "ストリーミング",
    "btnPrevious": "前へ"
  },
    "privacy": {
    "PrivacyPolicy": "Q-NEX Privacy Policy",
    "Byusing": "By using the Q-NEX service, you are trusting us to process your information. We understand that this responsibility is important, so we have been committed to protecting your information and giving you control.",
    "whatinformation": "This Privacy Policy is designed to help you understand what information we collect, why it is collected, and how you manage your information.",
    "EffectiveDate": "Effective Date: January 1, 2020",
    "title1": "Q-NEX Respects Your Privacy",
    "title1Respects1": "Returnstar Interactive Technology Group Co.,Ltd. and its sub-brand (collectively “Q-NEX”, “we” or “us”) respect your privacy and understand that the processing and security of your personal data is important to you. Please review the full Privacy Policy below for more complete details on how we collect, use, share, and protect your personal data, as well as the choices you have regarding our use and sharing of your personal data, along with other important considerations.",
    "title1Respects2": "This Privacy Policy explains Q-NEX’s practices regarding the processing (such as the collection, use, storage, copy or disclosure) of your personal data received: (i) through our website https://www.qnextech.com (“Website”), email, and other written or in person communications; (ii) in the context of all our commercial relations with customers, end-users, dealers, distributors, suppliers, contractors, agents or representatives; and (iii) in the normal course of any other potential business relationship. We commit to comply with our obligations under all applicable Privacy and Data Protection Laws, as described below, including but not limited to the Provisions on Protection of Personal Information of Telecommunications and Internet Users, and to respect your rights whenever we are processing your personal data.",
    "title2": "Privacy and Data Protection",
    "title2Respects1": "“Personal Data” means any information that identifies, or can be used to identify, an individual.",
    "title2Respects2": "“Privacy and Data Protection Laws” means any and/or all laws, rules, directives and regulations, on any local, provincial, state, federal or national level within and outside the People's Republic of China, pertaining to data privacy, data security and/or the protection of Personal Data. Among them, laws and regulations outside China include but not limited to: (a) the General Data Protection Regulation (GDPR) and each European Union Member States’ national implementation thereof; (b) the Australian Privacy Act 1988 (Cth) and the Australian Privacy Amendment (Enhancing Privacy Protection Act) (2012); (c) the Belgian Privacy Law of 8 December 1992; (d) the Canadian Personal Information Protection and Electronic Documents Act, SC 2000, c 5 (PIPEDA); (e) the Personal Data Protection Act 2012 of Singapore (PDPA); (f) additional privacy and data protection laws applicable to a data subject’s location; and (g) any successor legislation or regulations applicable thereto.",
    "title3": "When Do We Collect Your Personal Data?",
    "title3Respects1": "Q-NEX may collect your personal data when you communicate with us by phone, e-mail, the Website or otherwise, in the context of:",
    "title3a": "Browsing our Website or visiting our social media sites;",
    "title3b": "Corresponding with Q-NEX;",
    "title3c": "Visiting one of our offices, events or facilities;",
    "title3d": "Registering for and/or participating in our conferences, events, training or other activities;",
    "title3e": "Requesting information, support, service, materials, assistance or other inquiries;",
    "title3f": "Subscribing to a newsletter or other mailing list;",
    "title3g": "Exchanging business cards;",
    "title3h": "Completing Website contact forms, questionnaires, surveys, or contest entry forms or otherwise participating in these activities;",
    "title3i": "Engaging in commercial relationships or other collaboration;",
    "title3j": "Ordering or registering Q-NEX products;",
    "title3k": "Creating or registering an account;",
    "title3l": "Uploading or downloading files;",
    "title3m": "Verification of your identity as a data subject; or",
    "title3n": "Using Q-NEX products that are connected to the Internet, including mobile apps, cloudware, and certain hardware devices.",
    "title4": "Which Types of Personal Data are Processed by Us?",
    "title4Respects1": "Q-NEX may process the following personal data:",
    "title4a": "Name, surname, title, company, email address, phone number (mobile and landline), address, signature and other contact information;",
    "title4b": "IP addresses;",
    "title4c": "Location data;",
    "title4d": "Cookie ID;",
    "title4e": "Language;",
    "title4f": "Personal preferences regarding communications and/or products and services;",
    "title4g": "Financial details (e.g. payment information, bank account number, and credit information);",
    "title4h": "Personal data regarding projects using Q-NEX products and services;",
    "title4i": "Personal data provided in your submissions, responses and feedback;",
    "title4j": "Personal data regarding your interactions with Q-NEX, including your use of the Website and of Q-NEX’s products or services;",
    "title4k": "Social media data, images, photos, and camera footage; and",
    "title4l": "Any other personal data provided by you or by your authorized Q-NEX dealer or service provider.",
    "title4Respects2": "For the avoidance of doubt, Q-NEX does not collect any sensitive personal data, such as racial or ethnic origin; political opinions; religious or philosophical beliefs; genetic characteristics; health information; sexual preferences; information about children; criminal convictions; or biometric data, and we explicitly ask that you not provide us with such data in your responses or feedback to us.",
    "title5": "How Do We Use Your Personal Data?",
    "title5Respects1": "In order to better manage our own business needs and to better communicate with you, we may collect, analyze, use and otherwise process your personal data for the following purposes:",
    "title5a": "To respond to your inquiries, questions and other requests;",
    "title5b": "To optimize and manage the quality and content of our Website, including the ability to personalize and secure your Website experience;",
    "title5c": "To create and maintain your website, customer and product accounts and registrations;",
    "title5d": "To provide you with marketing, advertising, promotions, programs, offers and other opportunities; including newsletters, information on products and services, subscriptions, training, updates and direct marketing, which may be targeted, based on your communication preferences;",
    "title5e": "To conduct customer satisfaction studies, surveys and other market research;",
    "title5f": "To manage our events and activities, and invite you to events;",
    "title5g": "To register visitors to our offices, facilities and events;",
    "title5h": "To create promotional materials, including videos, photos, articles, case studies, newsletters and other materials regarding projects or events;",
    "title5i": "To provide products, services, training, technical support, customer service and other assistance;",
    "title5j": "To manage and perform our agreements and obligations;",
    "title5k": "To respond to and follow up on business leads, opportunities, and contacts;",
    "title5l": "To process payments, orders, invoicing, returns, collection and other requests;",
    "title5m": "To provide pricing, quotations and custom configurations of our products and services;",
    "title5n": "To grant you access to our software, training, technical information and other proprietary content;",
    "title5o": "To evaluate, troubleshoot, analyze and improve the use, functionality, features, and performance of our products, services, training, technical support and customer service;",
    "title5p": "To gather, analyze and maintain configuration and backup data regarding our products and services;",
    "title5q": "To facilitate planning, analytics, forecasting and reporting regarding our products and services;",
    "title5r": "To use for our internal business operations and processes, including business and financial recordkeeping, data management and business continuity; and",
    "title5s": "To meet our legal and regulatory obligations.",
    "title6": "Which Legal Basis Applies To Our Processing Of Your Personal Data?",
    "title6Respects1": "The following legal grounds might apply to the processing of your personal data for the purposes mentioned above:",
    "title6a": "Processing is necessary for the performance of your agreement with us or in order to take all pre-contractual steps;",
    "title6b": "Processing takes place based upon our legitimate interest (comply with obligations, maintain business records, fraud prevention, network and information security, etc.). When carrying out this type of processing, we strive to strike a balance between this legitimate interest and respect for your privacy;",
    "title6c": "You have given your consent to the processing (e.g. in case of direct marketing, for the processing of analytic cookies and for data transfers to third parties);",
    "title6d": "In order to comply with our legal obligations (such as tax administration and record retention); or",
    "title6e": "In very exceptional circumstances to protect your vital interest or that of someone else.",
    "titel7": "To Whom Do We Disclose Your Personal Data?",
    "title7Respects1": "Q-NEX may disclose your personal data to yourself, to Q-NEX’s affiliates or to third parties, such as payment providers, software providers, cloud partners, transport partners, financial institutions, insurance companies, legal services, or certain other service providers or partners that Q-NEX has a strategic relationship with, in order to fulfill our relationship with you in the most effective way.",
    "title7Respects2": "Q-NEX will not disclose to third parties any personal data you submit for purposes other than those described in this Privacy Policy. If, in the future, we intend to disclose your personal data to third parties for any purpose other than those described in this Privacy Policy we shall inform you thereof in advance and ask your consent if required.",
    "title7Respects3": "Notwithstanding the foregoing, Q-NEX will disclose your personal data to a third party (such as competent authorities) if required to do so by law, during a legal proceeding, or if, in good faith, Q-NEX believes that such action is necessary to comply with certain laws, rules or regulations.",
    "titel8": "Which Guarantees Do We Provide in Case of International Data Transfers?",
    "title8Respects1": "Q-NEX is a global company and we may transfer your information to Q-NEX affiliates, representatives or third party contractors who represent us worldwide. Each affiliate, representative, or third party contractor works closely with Q-NEX, and any transfer of personal data between these associated entities will comply with applicable Privacy and Data Protection Laws.",
    "title8Respects2": "If any transfer of the personal data of residents of the European Economic Area (EEA) is made to a person or entity located in a country outside of the EEA, that is not recognized as providing an adequate level of protection, we will provide for increased information security and appropriate contractual provisions to strengthen data protection. To ensure that any such transfers of the personal data of EEA residents are compliant with the applicable Privacy and Data Protection Laws, we will either (i) conclude a data transfer agreement, based upon the EU model agreements, (ii) adopt binding corporate rules, (iii) rely on legally determined exceptions (such as requesting your explicit consent) or (iv) adopt other mechanisms which have been deemed to provide for the adequate protection of your personal data.",
    "titel9": "How Do We Secure Your Personal Data?",
    "title9Respects1": "We use a variety of security technologies and precautions, such as the Secure Socket Layer (SSL) protocol (encryption), to help protect your personal data from loss, theft, misuse and unauthorized access, in accordance with industry standards. To protect any personal data stored on Q-NEX servers or cloud-based storage, we regularly monitor our systems for vulnerabilities or attacks, and implement up to date information security measures.",
    "title9Respects2": "Access to personal data that is processed by Q-NEX is limited only to those of its employees, contractors and affiliated organizations that need to know that information in order to process it on Q-NEX’s behalf, in accordance with this Privacy Policy, and that have agreed not to disclose it to others.",
    "titel10": "How Long Do We Retain Your Personal Data?",
    "title10Respects1": "Unless a longer retention period is required by law, Q-NEX will retain your personal data for as long as needed to fulfil the relevant purposes described in this Privacy Policy.",
    "titel11": "Use of Cookies",
    "title11Respects1": "Q-NEX uses cookies on our Website, both to enable the site to work properly, and to enhance your experience while visiting our Website. Cookie file(s), which are stored on the hard drive of your computer, enable us to obtain information about your usage of our Website, and to measure and improve the performance of our Website. Cookies enable you to store your preferences, in order to enable our Website to recognize these preferences when you browse our Website.",
    "title11Respects2": "You may refuse to accept cookies by activating the setting on your browser which allows you to refuse cookies. However, if you select this setting you may not be able to access certain sections or features of our Website. Unless you have adjusted your browser setting so that it will refuse cookies, our system will issue cookies to your computer whenever you log on to our Website.",
    "title11Respects3": "When you visit our Website for the first time you will be provided with a link to this cookie policy and will have the opportunity to change your browser settings to refuse cookies. By continuing to browse our website without changing your settings, you agree to our use of cookies as explained in this policy.",
    "title11Respects4GoogleAnalytics": "Google Analytics.",
    "title11Respects4": "We use industry standard web analytics to track visits to our sites, namely those provided by Google Analytics. The information generated by the cookies about your use of our Website (including your IP address) will be transmitted to and stored by Google Analytics on their servers and is handled in accordance with Google’s Privacy Policy which can be accessed at the following link: https://policies.google.com/privacy.",
    "titel12": "Third Party Links on our Website",
    "title12Respects1": "The Website contains links to other websites. Q-NEX is not responsible for the privacy policy of other websites, or the manner in which they store, use or distribute information. Q-NEX encourages you to review the privacy policy of any website you may visit.",
    "titel13": "Children’s Information",
    "title13Respects1": "Q-NEX’s Website is not intended for use by children, and its products and services are not sold to children. In accordance with the Children’s Online Privacy Protection Act, we do not collect or maintain information from persons we know are under 18, and no part of the Website is designed to attract anyone under age 18.",
    "titel14": "What Are Your Rights and How Can You Exercise Them?",
    "title14Respects1": "If you are a natural person, you have the right at all times to be informed about the personal data we process about you, and to the extent authorized under the applicable Privacy and Data Protection Laws, to request access, modification, limitation of processing, transfer or deletion of personal data, or to object to the processing of your personal data, subject to the exceptions within the applicable Privacy and Data Protection Laws.",
    "title14Respects2": "If processing is based solely on your consent, you also have the right to revoke your consent at any time, without prejudice to the lawfulness of processing prior to revocation.",
    "title14Respects3": "Through the contact options listed below, you can exercise the above rights regarding the processing of your personal data by Q-NEX, except in cases where this would require a disproportionate effort on the part of Q-NEX.",
    "title14Respects4": "Please feel free to use the contact information listed below if you have any additional concerns regarding your personal data or your exercise of the above rights, and we will do our best to assist you.",
    "title14Respects5": "If you contact us to exercise one of your rights under the applicable Privacy and Data Protection Laws, we will reply within one (1) month. In certain exceptional circumstances, we may take up to three (3) months to fully respond to you, but in such case we shall inform you why we require additional time to respond in our initial reply.",
    "title14Respects6": "If we are unable to resolve an inquiry or request, where applicable, you may have the right to lodge a complaint with the local data protection authority.",
    "titel15": "Stay Informed of Changes in Our Privacy Policy",
    "title15Respects1": "In a world in which technology and legislation is constantly changing, this Privacy Policy may also change. We invite you to always consult the latest version of this policy, posted at https://www.qnextech.com/legal, and we will inform you of any changes via our Website or other common communication channels.",
    "titel16": "Contact Q-NEX",
    "title16Respects1": "If you have questions and/or comments about this Privacy Policy or the manner in which Q-NEX collects, uses and/or processes your personal data, please contact us:",
    "title16Respects2": "Via e-mail: info@qnextech.com"
    }
}



// WEBPACK FOOTER //
// ./src/lang/ja.js